import { Dispatcher } from "flux";

// eslint-disable-next-line import/no-anonymous-default-export
export default new Dispatcher();
